// app/javascript/controllers/admin_user_auto_submit_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]

    submit() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.element.requestSubmit()
        }, 300) // Délai de 300ms pour éviter trop de requêtes
    }
}